var SchibstedAccountSessionHandler = /** @class */ (function () {
    function SchibstedAccountSessionHandler(identity, clientActions) {
        this.identity = identity;
        this.clientActions = clientActions;
    }
    SchibstedAccountSessionHandler.isHasSessionFailureResponse = function (response) {
        return response.error !== undefined;
    };
    SchibstedAccountSessionHandler.prototype.refreshSpidSession = function () {
        var _this = this;
        this.identity
            .hasSession(false)
            .then(function (response) {
            // Log success or failure.
            if (SchibstedAccountSessionHandler.isHasSessionFailureResponse(response)) {
                _this.clientActions.track('FailureResponse');
            }
            else {
                _this.clientActions.track('SuccessResponse');
            }
        })["catch"](function (exception) {
            // This error is so common it spams trackjs, ignore it
            if (exception.message !== 'HasSession failed') {
                console.error(exception);
            }
            _this.clientActions.track('ErrorResponse');
        });
    };
    return SchibstedAccountSessionHandler;
}());
export default SchibstedAccountSessionHandler;
